import React from 'react';
import styled from 'styled-components';
import Sticky from 'react-stickynode';
import Footer from "./Footer";
import Header from './Header';
import { breakpoints } from '../utils/styles';

const Sidebar = styled.div<{ fixed?: boolean }>`
  z-index: 1031;

  ${props => props.fixed && `
      @media (min-width: ${breakpoints.desktop}px) {
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          position: fixed;
          right: 0;
          top: 0;
        }
  `}
`;

interface Props {
  noSidePadding?: boolean;
  noTopMargin?: boolean;
  fixedSidebar?: boolean;
  sidebarOpen?: boolean;
  sidebarMobileToggle?: boolean;
  sidebarToggleNoButton?: boolean;
  sidebarAreaSelector?: boolean;
  sidebarCinemaSelector?: boolean;
  stickySidebar?: boolean;
  Header?: React.ReactNode;
  MainContent: React.ComponentType<any>;
  SidebarContent?: React.ComponentType<any>;
  [key: string]: any;
}

interface State {
  sidebarOpen: boolean;
}

class TwoColumnLayout extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.renderSidebar = this.renderSidebar.bind(this);
    this.renderSidebarContent = this.renderSidebarContent.bind(this);

    this.state = {
      sidebarOpen: !!props.sidebarOpen,
    };
  }

  toggle(e) {
    e.preventDefault();

    this.setState(state => ({sidebarOpen: !state.sidebarOpen}));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sidebarOpen !== this.props.sidebarOpen) {
      this.setState({sidebarOpen: !!this.props.sidebarOpen});
    }
  }

  render() {
    const {props} = this;

    return (
        <React.Fragment>
          <div id="the-body" className={'l-wrapper' + (props.sidebarMobileToggle ? ' l-wrapper--toggle-mobile' : '') + (this.state.sidebarOpen ? '  is-active' : '')}>
            <div className="l-wrapper__content top-nav-pad">
              {props.Header || <Header/>}
              <div className={props.noSidePadding === true ? '' : 'container'}>
                <div className={props.noTopMargin !== true ? 'mt-4' : ''}>
                  <props.MainContent {...props}/>
                </div>
              </div>
            </div>
            {props.SidebarContent && (
              <Sidebar fixed={props.fixedSidebar} className="l-wrapper__sidebar" id="the-sidebar">
                {props.sidebarMobileToggle && !props.sidebarToggleNoButton && <a className="l-wrapper__sidebar-toggle" onClick={this.toggle}>
                  <i className="fal fa-angle-left"></i>
                </a>}
                {this.renderSidebar()}
              </Sidebar>
            )}
          </div>
          <Footer/>
        </React.Fragment>
    );
  }

  renderSidebar() {
    if (this.props.stickySidebar === false || this.props.fixedSidebar) {
      return this.renderSidebarContent();
    }

    return (
        <Sticky bottomBoundary="#the-sidebar" enableTransforms={false}>
          {this.renderSidebarContent()}
        </Sticky>
    );
  }

  renderSidebarContent() {
    if (!this.props.SidebarContent) {
      return null;
    }

    return (
        <div className="l-wrapper__sidebar-content">
          <this.props.SidebarContent {...this.props} areaSelector={this.props.sidebarAreaSelector} cinemaSelector={this.props.sidebarCinemaSelector} />
        </div>
    );
  }
}

export default TwoColumnLayout;